var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaintPaletteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6256 15.1657C24.9606 15.1657 26.0428 14.0835 26.0428 12.7486C26.0428 11.4136 24.9606 10.3314 23.6256 10.3314C22.2907 10.3314 21.2085 11.4136 21.2085 12.7486C21.2085 14.0835 22.2907 15.1657 23.6256 15.1657Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9571 27.2514C14.6246 27.2514 15.1657 26.7103 15.1657 26.0429C15.1657 25.3754 14.6246 24.8343 13.9571 24.8343C13.2896 24.8343 12.7485 25.3754 12.7485 26.0429C12.7485 26.7103 13.2896 27.2514 13.9571 27.2514Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9571 18.7914C15.292 18.7914 16.3742 17.7092 16.3742 16.3743C16.3742 15.0394 15.292 13.9572 13.9571 13.9572C12.6221 13.9572 11.5399 15.0394 11.5399 16.3743C11.5399 17.7092 12.6221 18.7914 13.9571 18.7914Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0912 32.7625C26.0643 32.2936 25.9013 31.8428 25.6223 31.465C25.3433 31.0874 24.9603 30.7991 24.5201 30.6354C23.4268 30.276 22.4976 29.5385 21.8995 28.5555C21.3014 27.5722 21.0736 26.408 21.2571 25.2719C21.4406 24.1359 22.0234 23.1025 22.9006 22.3577C23.7779 21.6129 24.8921 21.2054 26.0429 21.2086H30.5629C31.3381 21.2108 32.1026 21.0264 32.7917 20.6712C33.4806 20.3159 34.0743 19.8002 34.5222 19.1674C34.9701 18.5346 35.2591 17.8034 35.3653 17.0355C35.4714 16.2675 35.3911 15.4853 35.1313 14.7548C34.17 12.0403 32.4809 9.64218 30.2489 7.82256C28.0169 6.00291 25.3278 4.83172 22.4752 4.43692C19.6227 4.04213 16.7165 4.43893 14.0742 5.58397C11.4318 6.72902 9.15505 8.57823 7.49254 10.9296C5.83003 13.281 4.84575 16.0441 4.64724 18.917C4.44873 21.7899 5.04363 24.6621 6.36695 27.2198C7.69024 29.7773 9.69105 31.9223 12.1508 33.4197C14.6105 34.9174 17.4345 35.7102 20.3142 35.7114C21.7364 35.7153 23.1521 35.5202 24.5201 35.1313C25.0225 34.9906 25.4576 34.6738 25.746 34.2389C26.0344 33.8041 26.1569 33.2803 26.0912 32.7625Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaintPaletteOutline);
export default __webpack_public_path__ + "static/media/icon_paint_palette_outline.a7b4c5b4c27e82e85dee080f0858ad1a.svg";
export { ForwardRef as ReactComponent };